module.exports = __webpack_public_path__ + "static/media/Bell_Exchange_logo.f83b8ffd.png";